/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelRateDelta } from './HotelRateDelta';
import {
    HotelRateDeltaFromJSON,
    HotelRateDeltaFromJSONTyped,
    HotelRateDeltaToJSON,
    HotelRateDeltaToJSONTyped,
} from './HotelRateDelta';

/**
 * A single completed batch's RATE deltas. One event fires per completed
 * batch; clients merge each item into the matching content card by
 * `vervotech_property_id` without reordering.
 * 
 * @export
 * @interface SearchStreamRates
 */
export interface SearchStreamRates {
    /**
     * 
     * @type {string}
     * @memberof SearchStreamRates
     */
    type: SearchStreamRatesTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchStreamRates
     */
    batchNum: number;
    /**
     * 
     * @type {Array<HotelRateDelta>}
     * @memberof SearchStreamRates
     */
    items: Array<HotelRateDelta>;
}


/**
 * @export
 */
export const SearchStreamRatesTypeEnum = {
    Rates: 'rates'
} as const;
export type SearchStreamRatesTypeEnum = typeof SearchStreamRatesTypeEnum[keyof typeof SearchStreamRatesTypeEnum];


/**
 * Check if a given object implements the SearchStreamRates interface.
 */
export function instanceOfSearchStreamRates(value: object): value is SearchStreamRates {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('batchNum' in value) || value['batchNum'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchStreamRatesFromJSON(json: any): SearchStreamRates {
    return SearchStreamRatesFromJSONTyped(json, false);
}

export function SearchStreamRatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamRates {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'batchNum': json['batch_num'],
        'items': ((json['items'] as Array<any>).map(HotelRateDeltaFromJSON)),
    };
}

export function SearchStreamRatesToJSON(json: any): SearchStreamRates {
    return SearchStreamRatesToJSONTyped(json, false);
}

export function SearchStreamRatesToJSONTyped(value?: SearchStreamRates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'batch_num': value['batchNum'],
        'items': ((value['items'] as Array<any>).map(HotelRateDeltaToJSON)),
    };
}

